var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _g2, _path30, _path31, _path32, _path33, _g3, _path34, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _path35, _g11, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsPtDelivery = function SvgNnIconFlagsPtDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-PT-delivery_svg__Lager_48",
    "data-name": "Lager 48",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-PT-delivery_svg__cls-1{fill:#ff1500}.nn-icon-flags-PT-delivery_svg__cls-11,.nn-icon-flags-PT-delivery_svg__cls-4{fill:#ffea00}.nn-icon-flags-PT-delivery_svg__cls-11,.nn-icon-flags-PT-delivery_svg__cls-4,.nn-icon-flags-PT-delivery_svg__cls-5{stroke:#600}.nn-icon-flags-PT-delivery_svg__cls-4,.nn-icon-flags-PT-delivery_svg__cls-5{stroke-linecap:round;stroke-linejoin:round}.nn-icon-flags-PT-delivery_svg__cls-11,.nn-icon-flags-PT-delivery_svg__cls-4,.nn-icon-flags-PT-delivery_svg__cls-5{stroke-width:.04px}.nn-icon-flags-PT-delivery_svg__cls-5{fill:none}.nn-icon-flags-PT-delivery_svg__cls-9{fill:#fff}.nn-icon-flags-PT-delivery_svg__cls-7{fill:#600}.nn-icon-flags-PT-delivery_svg__cls-8{fill:#04c}"))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__path1339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__path1339-2",
    "data-name": "path1339"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.12.13h50.22v33.56H.12z",
    className: "nn-icon-flags-PT-delivery_svg__cls-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1341",
    d: "M25 66.66h20V33.34H25Z",
    style: {
      fill: "#008034"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1355",
    d: "M36.75 50.47c1.55.83 5 1.25 8.24 1.28 3 0 6.83-.46 8.27-1.22v-.83c-.45.7-4.59 1.38-8.26 1.35s-7.08-.59-8.22-1.33v.75",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1357",
    d: "M53.34 50.35v.2a9.2 9.2 0 0 1-3.28.93 34 34 0 0 1-5.11.35 32 32 0 0 1-4.84-.34 11.9 11.9 0 0 1-3.46-.93v-.23a12.3 12.3 0 0 0 3.49 1 32 32 0 0 0 4.81.33 33.5 33.5 0 0 0 5.05-.37 10.3 10.3 0 0 0 3.31-.94Zm0-.71v.2a9.2 9.2 0 0 1-3.28.93 34 34 0 0 1-5.1.35 32 32 0 0 1-4.85-.33 12 12 0 0 1-3.46-.94v-.23a12.3 12.3 0 0 0 3.49 1 32 32 0 0 0 4.82.33 33.5 33.5 0 0 0 5.04-.36 10.5 10.5 0 0 0 3.31-1",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1359",
    d: "M53.34 50.35v.2a9.2 9.2 0 0 1-3.28.93 34 34 0 0 1-5.11.35 32 32 0 0 1-4.84-.34 11.9 11.9 0 0 1-3.46-.93v-.23a12.3 12.3 0 0 0 3.49 1 32 32 0 0 0 4.81.33 33.5 33.5 0 0 0 5.05-.37 10.3 10.3 0 0 0 3.31-.94Zm0-.71v.2a9.2 9.2 0 0 1-3.28.93 34 34 0 0 1-5.1.35 32 32 0 0 1-4.85-.33 12 12 0 0 1-3.46-.94v-.23a12.3 12.3 0 0 0 3.49 1 32 32 0 0 0 4.82.33 33.5 33.5 0 0 0 5.04-.36 10.5 10.5 0 0 0 3.31-1Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1343",
    d: "M51.52 55.17c-2.52-.08-14.05-7.28-14.13-8.43l.61-1.06c1.15 1.66 12.94 8.67 14.1 8.42l-.6 1.07",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1347",
    d: "M37.89 45.54c-.22.6 3 2.6 6.9 5s7.25 3.83 7.5 3.62a1.2 1.2 0 0 0 .12-.21c0 .07-.16.1-.34 0a38.7 38.7 0 0 1-7.19-3.62c-3.4-2.06-6.36-4-6.82-4.76a.6.6 0 0 1-.05-.24h0l-.1.17v0Zm13.69 9.66c0 .08-.12.08-.28.06-.94-.1-3.79-1.49-7.17-3.51-3.93-2.36-7.18-4.5-6.83-5.06l.1-.17h0c-.32.95 6.41 4.79 6.8 5 3.91 2.48 7.19 3.86 7.48 3.48l-.1.18Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1361",
    d: "M45 55a28.7 28.7 0 0 1-7.26-1.12l.47.73A19.6 19.6 0 0 0 45 55.75c2.71-.08 5.07-.29 6.74-1.11l.48-.76A25.3 25.3 0 0 1 45 55",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1363",
    d: "M51.94 54.47a4 4 0 0 1-.22.32 19 19 0 0 1-2.55.66 23 23 0 0 1-4.18.38 20 20 0 0 1-7-1.19l-.1-.17v0l.17.07A22.6 22.6 0 0 0 45 55.65a24 24 0 0 0 4.1-.38 12.7 12.7 0 0 0 2.77-.76h.06Zm.42-.68-.16.27a17.4 17.4 0 0 1-3.22.72 25 25 0 0 1-3.95.33A27.5 27.5 0 0 1 37.67 54l-.09-.18A31.2 31.2 0 0 0 45 54.93a27 27 0 0 0 4-.34 20.5 20.5 0 0 0 3.21-.71v0l.21-.07",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1365",
    d: "M51.94 54.47a4 4 0 0 1-.22.32 19 19 0 0 1-2.55.66 23 23 0 0 1-4.18.38 20 20 0 0 1-7-1.19l-.1-.17v0l.17.07A22.6 22.6 0 0 0 45 55.65a24 24 0 0 0 4.1-.38 12.7 12.7 0 0 0 2.77-.76h.06Zm.42-.68-.16.27a17.4 17.4 0 0 1-3.22.72 25 25 0 0 1-3.95.33A27.5 27.5 0 0 1 37.67 54l-.09-.18A31.2 31.2 0 0 0 45 54.93a27 27 0 0 0 4-.34 20.5 20.5 0 0 0 3.21-.71v0l.21-.07Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m27.66 13.29-.38-.63a8 8 0 0 1-2.32.64v.67a13 13 0 0 0 2.7-.68",
    className: "nn-icon-flags-PT-delivery_svg__cls-4"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m27.43 12.67-.13-.2a6.8 6.8 0 0 1-2.34.71v.19a8.3 8.3 0 0 0 2.47-.7M27.64 13.09a7 7 0 0 1-2.68.79v.2a10 10 0 0 0 2.8-.78h0Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 8.67a8.25 8.25 0 1 0 8.24 8.24 8.26 8.26 0 0 0-8.24-8.24m0 15.61a7.37 7.37 0 1 1 7.37-7.37 7.4 7.4 0 0 1-7.37 7.37",
    className: "nn-icon-flags-PT-delivery_svg__cls-4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 8.85a8.07 8.07 0 1 0 8.06 8.06 8.1 8.1 0 0 0-8.06-8.06m0 15.61a7.55 7.55 0 1 1 7.56-7.55 7.58 7.58 0 0 1-7.56 7.55",
    className: "nn-icon-flags-PT-delivery_svg__cls-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1377",
    d: "M45.26 41.63v.09h-.52v-.08h-.18v16.75h.18v-.08h.52v.09h.18V41.63Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.97 8.63v16.59M20.5 8.63v16.59",
    className: "nn-icon-flags-PT-delivery_svg__cls-5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1397",
    d: "M45 44.42a17.8 17.8 0 0 1 7 1l.45.78A17.9 17.9 0 0 0 45 45.17c-2.81 0-5.83.31-7.34 1.11l.53-.89c1.24-.64 4.17-1 6.81-1",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1401",
    d: "M45 45.05a28.7 28.7 0 0 1 4.79.34 9 9 0 0 1 2.62.77l.13.24a9.6 9.6 0 0 0-2.78-.83 27.3 27.3 0 0 0-4.76-.33 28 28 0 0 0-4.83.33 8.5 8.5 0 0 0-2.6.81l.13-.25a9 9 0 0 1 2.44-.74 29 29 0 0 1 4.86-.34m0-.7a27 27 0 0 1 4.62.32 7.8 7.8 0 0 1 2.39.78l.19.31a6.35 6.35 0 0 0-2.66-.91 29 29 0 0 0-4.54-.32 27 27 0 0 0-4.64.34 7.6 7.6 0 0 0-2.31.71l.17-.25a8.2 8.2 0 0 1 2.11-.64 27.4 27.4 0 0 1 4.67-.34",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1419",
    d: "M38.08 45.38c2.54 0 14.24 7.15 14.27 8.47L51.62 55c-.32-1.53-12.19-8.52-14.15-8.39l.61-1.19",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1425",
    d: "M37.4 46.53c.47-.32 3.92 1.22 7.54 3.4s7.05 4.65 6.74 5.12l-.1.16h0s.06-.08 0-.25c-.15-.5-2.6-2.45-6.65-4.9s-7.25-3.78-7.58-3.37l.11-.2Zm15 7.4c.3-.58-2.91-3-6.88-5.35s-7-3.66-7.53-3.26l-.12.22h0a.5.5 0 0 1 .33-.08c.92 0 3.56 1.22 7.25 3.34 1.62.94 6.83 4.29 6.81 5.23v.13l.13-.2",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1387",
    d: "M36.72 49.66c1-.95 4.85-1.57 8.23-1.56s7.4.72 8.27 1.54v.71c-.73-.69-3.85-1.51-8.27-1.52s-7.63.83-8.24 1.54v-.71",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1393",
    d: "M45 48.73a29 29 0 0 1 5.33.48 6.14 6.14 0 0 1 3 1.13v.21a6.64 6.64 0 0 0-3-1.16 28 28 0 0 0-5.3-.47 29.7 29.7 0 0 0-5.41.48c-1.18.23-2.75.7-2.94 1.15v-.22c.1-.32 1.27-.79 2.91-1.12a31 31 0 0 1 5.41-.48m0-.73a29 29 0 0 1 5.33.48 6.25 6.25 0 0 1 3 1.13v.22a6.64 6.64 0 0 0-3-1.17 28.7 28.7 0 0 0-5.3-.47 29.6 29.6 0 0 0-5.4.48c-1.14.22-2.77.7-3 1.16v-.23c.1-.31 1.3-.8 2.91-1.11A30 30 0 0 1 45 48",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1405",
    d: "M49.1 53.44a20.4 20.4 0 0 0-4.1-.31c-5.12 0-6.77 1-7 1.34l-.38-.62c1.3-.94 4.08-1.47 7.37-1.42a26.3 26.3 0 0 1 4.43.38l-.35.63",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1411",
    d: "M45 53a24.7 24.7 0 0 1 4.16.33l-.09.17a21.6 21.6 0 0 0-4.07-.27 19.4 19.4 0 0 0-5.46.64c-.52.14-1.39.48-1.48.76l-.09-.16c0-.17.55-.51 1.53-.78A19.5 19.5 0 0 1 45 53m.06-.72a26 26 0 0 1 4.48.39l-.1.18a23.3 23.3 0 0 0-4.44-.34 21 21 0 0 0-5.73.67c-.59.17-1.6.54-1.64.83l-.09-.17c0-.26.9-.61 1.69-.84a20.7 20.7 0 0 1 5.77-.68Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1431",
    d: "M40.06 50.92A5 5 0 0 0 45 55.86a5 5 0 0 0 3.5-1.45 4.9 4.9 0 0 0 1.45-3.49v-6.59h-9.89z",
    style: {
      stroke: "#600",
      fill: "#fff",
      strokeWidth: ".05px"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 22.54a4.75 4.75 0 0 1-4.72-4.7v-6.4h9.46v6.37a4.71 4.71 0 0 1-4.74 4.73m-2.85-4.69a2.86 2.86 0 0 0 .85 2.06 2.81 2.81 0 0 0 4 0 2.72 2.72 0 0 0 .82-1.65 2 2 0 0 0 0-.36v-4.5h-5.71Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.53 11.49h9.38v6.34a4.69 4.69 0 0 1-4.68 4.68 4.72 4.72 0 0 1-3.32-1.37 4.64 4.64 0 0 1-1.38-3.3zm4.7 9.24a2.87 2.87 0 0 0 2-.82 2.8 2.8 0 0 0 .83-1.67v-4.93h-5.72v4.55a2.9 2.9 0 0 0 .89 2.05 2.87 2.87 0 0 0 2 .85m-4.73-9.29v6.4a4.68 4.68 0 0 0 1.4 3.33 4.74 4.74 0 0 0 8.09-3.33v-6.42Zm4.73 9.21a2.85 2.85 0 0 1-2.81-2.83v-4.5h5.66v4.91a2.82 2.82 0 0 1-2.85 2.42",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1485",
    d: "M44.39 48a.7.7 0 0 0 .18.48.6.6 0 0 0 .89 0 .7.7 0 0 0 .18-.47v-.9h-1.25z",
    className: "nn-icon-flags-PT-delivery_svg__cls-8",
    transform: "translate(-24.77 -33.09)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944",
    d: "M44.68 47.35a.13.13 0 0 0-.13.13.12.12 0 0 0 .13.12.12.12 0 0 0 .12-.12.13.13 0 0 0-.12-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    transform: "translate(-24.77 -33.09)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-2",
    d: "M45.35 47.35a.13.13 0 0 0-.12.13.12.12 0 0 0 .12.12.12.12 0 0 0 .13-.12.13.13 0 0 0-.13-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-3",
    d: "M45 47.69a.12.12 0 0 0-.13.12.13.13 0 0 0 .13.13.12.12 0 0 0 .12-.13.12.12 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-4",
    d: "M45.35 48a.12.12 0 1 0 0 .24.12.12 0 1 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-5",
    d: "M44.68 48a.12.12 0 1 0 0 .24.12.12 0 0 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use3438"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1485-2",
    d: "M44.39 50.2a.7.7 0 0 0 .18.47.6.6 0 0 0 .44.2.62.62 0 0 0 .45-.19.73.73 0 0 0 .18-.48v-.9h-1.25z",
    className: "nn-icon-flags-PT-delivery_svg__cls-8",
    "data-name": "path1485",
    transform: "translate(-24.77 -33.09)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use5954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-6",
    d: "M45.37 50.2a.13.13 0 0 0-.13.13.13.13 0 0 0 .13.12.12.12 0 0 0 .12-.12.12.12 0 0 0-.12-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-7",
    d: "M44.68 50.2a.13.13 0 0 0-.13.13.13.13 0 0 0 .13.12.13.13 0 0 0 .12-.12.13.13 0 0 0-.12-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-8",
    d: "M45 49.85a.12.12 0 0 0-.12.13.12.12 0 0 0 .12.12.12.12 0 0 0 .13-.12.13.13 0 0 0-.13-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-9",
    d: "M45.37 49.52a.12.12 0 0 0-.12.13.12.12 0 0 0 .24 0 .12.12 0 0 0-.12-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-10",
    d: "M44.68 49.52a.13.13 0 0 0-.13.12.13.13 0 0 0 .13.13.13.13 0 0 0 .12-.13.13.13 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use3436"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1485-3",
    d: "M46.12 50.2a.7.7 0 0 0 .18.48.62.62 0 0 0 .44.2.6.6 0 0 0 .44-.2.67.67 0 0 0 .19-.47v-.9h-1.25z",
    className: "nn-icon-flags-PT-delivery_svg__cls-8",
    "data-name": "path1485",
    transform: "translate(-24.77 -33.09)"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-11",
    d: "M47.09 50.21a.12.12 0 1 0 0 .24.12.12 0 1 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use5946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-12",
    d: "M46.42 50.21a.12.12 0 1 0 .12.12.12.12 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use5948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-13",
    d: "M46.75 49.86a.12.12 0 0 0-.12.12.12.12 0 1 0 .24 0 .12.12 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use5950"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-14",
    d: "M47.1 49.53a.12.12 0 1 0 0 .24.12.12 0 0 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use5952"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-15",
    d: "M46.42 49.52a.13.13 0 0 0-.13.13.12.12 0 0 0 .13.12.12.12 0 0 0 .12-.12.12.12 0 0 0-.12-.13",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use3434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1485-4",
    d: "M44.38 52.35a.67.67 0 0 0 .19.47.58.58 0 0 0 .88 0 .7.7 0 0 0 .18-.47v-.9h-1.24v.9",
    className: "nn-icon-flags-PT-delivery_svg__cls-8",
    "data-name": "path1485",
    transform: "translate(-24.77 -33.09)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use6358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-16",
    d: "M45.36 52.35a.12.12 0 0 0-.12.12.12.12 0 0 0 .12.13.13.13 0 0 0 .13-.13.12.12 0 0 0-.13-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use6360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-17",
    d: "M44.68 52.35a.13.13 0 0 0-.13.12.13.13 0 0 0 .13.13.13.13 0 0 0 .12-.13.13.13 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use6356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-18",
    d: "M45 52a.13.13 0 0 0-.12.13.13.13 0 0 0 .12.12.13.13 0 0 0 .13-.12A.13.13 0 0 0 45 52",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use6352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-19",
    d: "M45.36 51.67a.12.12 0 0 0-.12.12.12.12 0 0 0 .12.13.13.13 0 0 0 .13-.13.12.12 0 0 0-.13-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-20",
    d: "M44.68 51.67a.12.12 0 0 0-.13.12.13.13 0 0 0 .13.13.13.13 0 0 0 .12-.13.12.12 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-PT-delivery_svg__use3440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__path1485-5",
    d: "M42.66 50.21a.7.7 0 0 0 .18.47.6.6 0 0 0 .89 0 .7.7 0 0 0 .18-.47v-.9h-1.25z",
    className: "nn-icon-flags-PT-delivery_svg__cls-8",
    "data-name": "path1485",
    transform: "translate(-24.77 -33.09)"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-21",
    d: "M43.64 50.21a.12.12 0 1 0 0 .24.12.12 0 1 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-22",
    d: "M43 50.21a.12.12 0 1 0 0 .24.12.12 0 1 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-23",
    d: "M43.29 49.86a.12.12 0 0 0-.12.12.12.12 0 1 0 .24 0 .12.12 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-24",
    d: "M43.64 49.53a.12.12 0 1 0 0 .24.12.12 0 1 0 0-.24",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use6320",
    d: "M43 49.53a.12.12 0 1 0 .12.12.12.12 0 0 0-.12-.12",
    style: {
      fill: "#ff0"
    },
    transform: "translate(-24.77 -33.09)"
  }), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-PT-delivery_svg__use5944-25",
    d: "M43 49.53a.12.12 0 1 0 .12.12.12.12 0 0 0-.12-.12",
    className: "nn-icon-flags-PT-delivery_svg__cls-9",
    "data-name": "use5944",
    transform: "translate(-24.77 -33.09)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "m17.12 13.08-.06-.51h-1.25l-.06.51zM17.14 13.21a.06.06 0 0 0 .05-.06.07.07 0 0 0-.05-.07h-1.42s-.05 0-.05.07 0 .06.05.06ZM17.11 12.46a.06.06 0 0 0 0-.12h-1.36a.06.06 0 0 0 0 .12Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.07 12.57a.06.06 0 0 0 .06-.06.06.06 0 0 0-.06-.05h-1.29a.05.05 0 0 0 0 .05.06.06 0 0 0 0 .06ZM16.23 11.58v.16h.42v-.17h-.1v.08h-.08v-.07h-.1v.08h-.08v-.07ZM16.59 11.78h-.31l-.03.56h.36zM16.71 12.05l-.01.29h.35l-.01-.29zM16.65 11.84v.17h.36v-.17h-.11v.07h-.07v-.07h-.1v.07h-.08zM15.76 11.84V12h.36v-.17h-.1v.08h-.07v-.07h-.02v.07h-.07v-.07ZM15.82 12.34h.34l-.01-.29h-.32z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.39 11.97v.13h.08v-.13zM16.84 12.16v.1h.06v-.1s-.06-.05-.06 0M15.95 12.16v.1h.07v-.1z",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 12.58a.46.46 0 0 0-.34.5h.68a.51.51 0 0 0-.34-.5Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 12.73a.36.36 0 0 0-.19.35h.38a.36.36 0 0 0-.19-.35ZM20.91 13.08l-.06-.51h-1.26l-.05.51zM20.92 13.21a.06.06 0 0 0 .06-.06.07.07 0 0 0-.06-.07h-1.41s-.05 0-.05.07 0 .06.05.06ZM20.89 12.46a.06.06 0 1 0 0-.12h-1.35a.06.06 0 0 0 0 .12Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M20.86 12.57v-.11h-1.29l-.05.05s0 .06.05.06ZM19.99 11.58v.16h.37v-.17h-.11v.08h-.02v-.07h-.11v.08h-.07v-.07ZM20.38 11.78h-.32l-.02.56h.36zM20.5 12.05l-.01.29h.34l-.01-.29zM20.43 11.84v.17h.36v-.17h-.1v.07h-.07v-.07h-.11v.07h.02v-.07ZM19.55 11.84V12h.37v-.17h-.1v.08h-.08v-.07h-.1v.07h-.07v-.07ZM19.61 12.34h.34l-.01-.29h-.33z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 11.97v.13zM20.62 12.16v.1h.07v-.1zM19.74 12.16v.1h.07v-.1z",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 12.58a.48.48 0 0 0-.34.5h.68a.48.48 0 0 0-.34-.5Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M20.23 12.73a.38.38 0 0 0-.19.35h.39a.36.36 0 0 0-.2-.35ZM17.13 16.94l-.07-.51h-1.25l-.06.51zM17.14 17.07a.06.06 0 0 0 .09-.06s0-.07-.05-.07h-1.45a.07.07 0 0 0-.06.07.06.06 0 0 0 .06.06ZM17.11 16.31v-.06h-1.35s-.05 0-.05.06h.05ZM17.08 16.43a.06.06 0 0 0 0-.12h-1.29a.06.06 0 0 0 0 .12ZM16.23 15.43v.17h.42v-.17h-.1v.07h-.08v-.07h-.1v.07h-.07v-.07ZM16.59 15.64h-.31l-.02.55h.35zM16.71 15.9l-.01.29h.35l-.01-.29z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.65 15.7v.21H17v-.16h-.1v.07h-.08v-.07h-.1v.07h-.07v-.07ZM15.77 15.7v.21h.36a.05.05 0 0 0 .1 0v-.16h-.11v.07h-.07v-.07h-.1v.07h-.08v-.07Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.82 16.19h.35l-.02-.29h-.32z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4 15.83v.08h.07v-.12c0-.02-.07-.02-.07.04M16.84 16.01v.1h.07v-.1zM15.95 16.01v.1h.07v-.1z",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 16.43a.47.47 0 0 0-.34.51h.68a.51.51 0 0 0-.34-.51Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16.43 16.59a.36.36 0 0 0-.2.32h.39a.36.36 0 0 0-.19-.32ZM18.3 20.23l-.41-.32-.88.89.32.4zM18.4 20.32a.06.06 0 0 0 0-.09.06.06 0 0 0-.08 0l-1 1a.06.06 0 0 0 0 .09.05.05 0 0 0 .08 0ZM17.84 19.8a.06.06 0 0 0-.08-.08l-1 1v.07a.05.05 0 0 0 .08 0Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9 19.91v-.07h-.08l-.91.92v.07h.08ZM16.58 19.82l.12.12h.06l.26-.26v-.06l-.12-.12-.07.08v.05h-.05l-.08.07.05.06h-.05Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m17 19.69-.22.22.38.41.25-.25zM17.28 19.79l.2.21.24-.24-.22-.2z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "m17.08 19.69.12.12h.06l.25-.26v-.06l-.12-.12-.08.08.06.05h-.11l-.07.07.05.05h-.05ZM16.46 20.32l.11.11h.07l.25-.25v-.06l-.12-.12-.07.07.05.05h-.05l-.07.07v.06h-.05Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "m16.85 20.63.24-.24-.21-.2-.23.23z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m16.99 19.96.09.09-.04-.14s-.09 0-.05.05M17.44 19.78l.07.07zs-.04-.04 0 0M16.81 20.41l.07.07h.05l-.07-.07s-.08-.04-.05 0",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M17.45 20.37a.46.46 0 0 0 .12.6l.48-.49a.5.5 0 0 0-.6-.11Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.56 20.48a.36.36 0 0 0 .11.38l.27-.27a.34.34 0 0 0-.38-.11ZM23.32 13.08l.06-.51h1.25l.06.51zM23.3 13.21a.06.06 0 0 1-.06-.06.07.07 0 0 1 .06-.07h1.41s.05 0 .05.07 0 .06-.05.06ZM23.32 12.46a.06.06 0 0 1 0-.12h1.36a.06.06 0 0 1 0 .12Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M23.36 12.57s-.05 0-.05-.06l.05-.05h1.29a.05.05 0 0 1 0 .05.06.06 0 0 1 0 .06ZM24.23 11.58v.16h-.41v-.17h.11v.08H24v-.07h.11v.08h.07v-.07ZM23.85 11.78h.31l.02.56h-.35zM23.73 12.05l.01.29h-.35l.01-.29zM23.79 11.84v.17h-.41v-.17h.11v.07h.07v-.07h.1v.07h.08v-.07ZM24.67 11.84V12h-.44v-.17h.1v.08h.08v-.07h.1v.07h.07v-.07ZM24.62 12.34h-.35l.02-.29h.32z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.04 11.97v.13h-.07v-.13zM23.59 12.16v.1h-.06v-.1s.06-.05.06 0M24.48 12.16v.1h-.07v-.1z",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.58a.46.46 0 0 1 .34.5h-.68a.51.51 0 0 1 .34-.5Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24 12.73a.36.36 0 0 1 .19.35h-.38a.36.36 0 0 1 .19-.35ZM23.31 16.94l.06-.51h1.26l.05.51zM23.29 17.07a.06.06 0 0 1-.06-.06s0-.07.05-.07h1.41a.07.07 0 0 1 .06.07.06.06 0 0 1-.06.06ZM23.32 16.31h-.05s0-.06.05-.06h1.35a.06.06 0 0 1 .06.06.06.06 0 0 1-.06 0Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M23.35 16.43a.06.06 0 0 1 0-.12h1.3v.12ZM24.23 15.43v.17h-.37v-.17h.1v.07h.08v-.07h.1v.07h.08v-.07ZM23.85 15.64h.31l.02.55h-.36zM23.72 15.9l.01.29h-.34l.01-.29z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M23.78 15.7v.21h-.35v-.16h.1v.07h.08v-.07h.1v.07h.07v-.07ZM24.66 15.7v.21h-.43v-.16h.11v.07h.07v-.07h.1v.07h.08v-.07Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.61 16.19h-.34l.01-.29h.33z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.03 15.83v.08h-.07v-.12c0-.02.08-.02.07.04M23.59 16.01v.1h-.07v-.1zM24.48 16.01v.1h-.07v-.1z",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.43a.47.47 0 0 1 .34.51h-.68a.51.51 0 0 1 .34-.51Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.59a.36.36 0 0 1 .23.32h-.38a.36.36 0 0 1 .15-.32ZM22.14 20.23l.41-.32.88.89-.32.4zM22.03 20.32a.06.06 0 0 1 0-.09s.06 0 .08 0l1 1a.06.06 0 0 1 0 .09.05.05 0 0 1-.08 0ZM22.59 19.8a.06.06 0 0 1 .08-.08l1 1v.07a.05.05 0 0 1-.08 0Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M22.53 19.91a.06.06 0 0 1 .08-.08l.91.92v.07h-.08ZM23.85 19.82l-.12.09h-.06l-.26-.26v-.06l.12-.12.07.08v.05h.05l.08.07v.06ZM23.43 19.69l.23.22-.38.41-.25-.25zM23.16 19.79l-.2.21-.24-.24.21-.2z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m23.35 19.69-.12.12h-.06l-.25-.26v-.06l.12-.12.08.08-.06.05h.06l.07.07v.05ZM23.98 20.32l-.12.11h-.07l-.25-.25v-.06l.12-.12.07.07v.05l.07.07v.06h.05Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "m23.59 20.63-.25-.24.22-.2.23.23z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m23.44 19.96-.09.09zs.04-.05 0 0M22.99 19.78l-.07.07zs.04-.04 0 0M23.62 20.41l-.07.07zs.03-.04 0 0",
    className: "nn-icon-flags-PT-delivery_svg__cls-7"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M22.98 20.37a.46.46 0 0 1-.12.6l-.47-.49a.49.49 0 0 1 .59-.11Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M22.88 20.48a.38.38 0 0 1-.12.38l-.27-.27a.35.35 0 0 1 .39-.11Z",
    className: "nn-icon-flags-PT-delivery_svg__cls-11"
  })));
};
export default SvgNnIconFlagsPtDelivery;